/**
 * Anchors the filter dropdown left or right depending on the position of the button in relation to the
 * viewport.
 */
const decideDropdownXPosition = (e: React.MouseEvent) => {
    if (typeof window === "undefined") {
        return { left: 0 };
    }

    const position = (e.target as HTMLElement).getBoundingClientRect();

    const { left, width } = position;
    const right = window.innerWidth - (left + width);

    return left <= right ? { left: 0 } : { right: 0 };
};

export default decideDropdownXPosition;
